import { getRuntimeConfig } from "@/config/runtimeConfig";
import { adminAPI } from "@/project/jain_elibrary-admin/services/adminService";
import { axiosConfig } from "@/services/axiosConfig";

export function applyRuntimeClients(): void {
  const { apiUrl } = getRuntimeConfig();
  adminAPI.defaults.baseURL = apiUrl;
  axiosConfig.defaults.baseURL = apiUrl;
}
